// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// GENERATED FILE: no manual modifications

export type IsoLanguage = { id: string; alpha2: string; nameFi: string }

const isoLanguages: Record<string, IsoLanguage> = {
  aar: { id: "aar", alpha2: "aa", nameFi: "afar" },
  abk: { id: "abk", alpha2: "ab", nameFi: "abhaasi" },
  afr: { id: "afr", alpha2: "af", nameFi: "afrikaans" },
  aka: { id: "aka", alpha2: "ak", nameFi: "akan" },
  amh: { id: "amh", alpha2: "am", nameFi: "amhara" },
  ara: { id: "ara", alpha2: "ar", nameFi: "arabia" },
  arg: { id: "arg", alpha2: "an", nameFi: "aragonia" },
  asm: { id: "asm", alpha2: "as", nameFi: "assami" },
  ava: { id: "ava", alpha2: "av", nameFi: "avaari" },
  ave: { id: "ave", alpha2: "ae", nameFi: "avesta" },
  aym: { id: "aym", alpha2: "ay", nameFi: "aimara" },
  aze: { id: "aze", alpha2: "az", nameFi: "azeri" },
  bak: { id: "bak", alpha2: "ba", nameFi: "baškiiri" },
  bam: { id: "bam", alpha2: "bm", nameFi: "bambara" },
  bel: { id: "bel", alpha2: "be", nameFi: "valkovenäjä" },
  ben: { id: "ben", alpha2: "bn", nameFi: "bengali" },
  bis: { id: "bis", alpha2: "bi", nameFi: "bislama" },
  bod: { id: "bod", alpha2: "bo", nameFi: "tiibet" },
  bos: { id: "bos", alpha2: "bs", nameFi: "bosnia" },
  bre: { id: "bre", alpha2: "br", nameFi: "bretoni" },
  bul: { id: "bul", alpha2: "bg", nameFi: "bulgaria" },
  cat: { id: "cat", alpha2: "ca", nameFi: "katalaani" },
  ces: { id: "ces", alpha2: "cs", nameFi: "tšekki" },
  cha: { id: "cha", alpha2: "ch", nameFi: "tšamorro" },
  che: { id: "che", alpha2: "ce", nameFi: "tšetšeeni" },
  chu: { id: "chu", alpha2: "cu", nameFi: "kirkkoslaavi" },
  chv: { id: "chv", alpha2: "cv", nameFi: "tšuvassi" },
  cor: { id: "cor", alpha2: "kw", nameFi: "korni" },
  cos: { id: "cos", alpha2: "co", nameFi: "korsika" },
  cre: { id: "cre", alpha2: "cr", nameFi: "cree" },
  cym: { id: "cym", alpha2: "cy", nameFi: "kymri" },
  dan: { id: "dan", alpha2: "da", nameFi: "tanska" },
  deu: { id: "deu", alpha2: "de", nameFi: "saksa" },
  div: { id: "div", alpha2: "dv", nameFi: "divehi" },
  dzo: { id: "dzo", alpha2: "dz", nameFi: "dzongkha" },
  ell: { id: "ell", alpha2: "el", nameFi: "kreikka" },
  eng: { id: "eng", alpha2: "en", nameFi: "englanti" },
  epo: { id: "epo", alpha2: "eo", nameFi: "esperanto" },
  est: { id: "est", alpha2: "et", nameFi: "viro" },
  eus: { id: "eus", alpha2: "eu", nameFi: "baski" },
  ewe: { id: "ewe", alpha2: "ee", nameFi: "ewe" },
  fao: { id: "fao", alpha2: "fo", nameFi: "fääri" },
  fas: { id: "fas", alpha2: "fa", nameFi: "persia" },
  fij: { id: "fij", alpha2: "fj", nameFi: "fidži" },
  fil: { id: "fil", alpha2: "", nameFi: "filipino" },
  fin: { id: "fin", alpha2: "fi", nameFi: "suomi" },
  fra: { id: "fra", alpha2: "fr", nameFi: "ranska" },
  fry: { id: "fry", alpha2: "fy", nameFi: "länsifriisi" },
  ful: { id: "ful", alpha2: "ff", nameFi: "fulani" },
  gla: { id: "gla", alpha2: "gd", nameFi: "gaeli" },
  gle: { id: "gle", alpha2: "ga", nameFi: "iiri" },
  glg: { id: "glg", alpha2: "gl", nameFi: "galicia" },
  glv: { id: "glv", alpha2: "gv", nameFi: "manksi" },
  grn: { id: "grn", alpha2: "gn", nameFi: "guarani" },
  guj: { id: "guj", alpha2: "gu", nameFi: "gudžarati" },
  hat: { id: "hat", alpha2: "ht", nameFi: "haiti" },
  hau: { id: "hau", alpha2: "ha", nameFi: "hausa" },
  hbs: { id: "hbs", alpha2: "sh", nameFi: "serbokroaatti" },
  heb: { id: "heb", alpha2: "he", nameFi: "heprea" },
  her: { id: "her", alpha2: "hz", nameFi: "herero" },
  hin: { id: "hin", alpha2: "hi", nameFi: "hindi" },
  hmo: { id: "hmo", alpha2: "ho", nameFi: "hiri-motu" },
  hrv: { id: "hrv", alpha2: "hr", nameFi: "kroatia" },
  hun: { id: "hun", alpha2: "hu", nameFi: "unkari" },
  hye: { id: "hye", alpha2: "hy", nameFi: "armenia" },
  ibo: { id: "ibo", alpha2: "ig", nameFi: "igbo" },
  ido: { id: "ido", alpha2: "io", nameFi: "ido" },
  iii: { id: "iii", alpha2: "ii", nameFi: "sichuanin-yi" },
  iku: { id: "iku", alpha2: "iu", nameFi: "inuktitut" },
  ile: { id: "ile", alpha2: "ie", nameFi: "interlingue" },
  ina: { id: "ina", alpha2: "ia", nameFi: "interlingua" },
  ind: { id: "ind", alpha2: "id", nameFi: "indonesia" },
  ipk: { id: "ipk", alpha2: "ik", nameFi: "inupiaq" },
  isl: { id: "isl", alpha2: "is", nameFi: "islanti" },
  ita: { id: "ita", alpha2: "it", nameFi: "italia" },
  jav: { id: "jav", alpha2: "jv", nameFi: "jaava" },
  jpn: { id: "jpn", alpha2: "ja", nameFi: "japani" },
  kal: { id: "kal", alpha2: "kl", nameFi: "kalaallisut" },
  kan: { id: "kan", alpha2: "kn", nameFi: "kannada" },
  kas: { id: "kas", alpha2: "ks", nameFi: "kašmiri" },
  kat: { id: "kat", alpha2: "ka", nameFi: "georgia" },
  kau: { id: "kau", alpha2: "kr", nameFi: "kanuri" },
  kaz: { id: "kaz", alpha2: "kk", nameFi: "kazakki" },
  khm: { id: "khm", alpha2: "km", nameFi: "khmer" },
  kik: { id: "kik", alpha2: "ki", nameFi: "kikuju" },
  kin: { id: "kin", alpha2: "rw", nameFi: "ruanda" },
  kir: { id: "kir", alpha2: "ky", nameFi: "kirgiisi" },
  kom: { id: "kom", alpha2: "kv", nameFi: "komi" },
  kon: { id: "kon", alpha2: "kg", nameFi: "kongo" },
  kor: { id: "kor", alpha2: "ko", nameFi: "korea" },
  kua: { id: "kua", alpha2: "kj", nameFi: "kuanjama" },
  kur: { id: "kur", alpha2: "ku", nameFi: "kurdi" },
  lao: { id: "lao", alpha2: "lo", nameFi: "lao" },
  lat: { id: "lat", alpha2: "la", nameFi: "latina" },
  lav: { id: "lav", alpha2: "lv", nameFi: "latvia" },
  lim: { id: "lim", alpha2: "li", nameFi: "limburg" },
  lin: { id: "lin", alpha2: "ln", nameFi: "lingala" },
  lit: { id: "lit", alpha2: "lt", nameFi: "liettua" },
  ltz: { id: "ltz", alpha2: "lb", nameFi: "luxemburg" },
  lub: { id: "lub", alpha2: "lu", nameFi: "katanganluba" },
  lug: { id: "lug", alpha2: "lg", nameFi: "ganda" },
  mah: { id: "mah", alpha2: "mh", nameFi: "marshall" },
  mal: { id: "mal", alpha2: "ml", nameFi: "malajalam" },
  mar: { id: "mar", alpha2: "mr", nameFi: "marathi" },
  mkd: { id: "mkd", alpha2: "mk", nameFi: "makedonia" },
  mlg: { id: "mlg", alpha2: "mg", nameFi: "malagassi" },
  mlt: { id: "mlt", alpha2: "mt", nameFi: "malta" },
  mon: { id: "mon", alpha2: "mn", nameFi: "mongoli" },
  mri: { id: "mri", alpha2: "mi", nameFi: "maori" },
  msa: { id: "msa", alpha2: "ms", nameFi: "malaiji" },
  mya: { id: "mya", alpha2: "my", nameFi: "burma" },
  nau: { id: "nau", alpha2: "na", nameFi: "nauru" },
  nav: { id: "nav", alpha2: "nv", nameFi: "navajo" },
  nbl: { id: "nbl", alpha2: "nr", nameFi: "etelä-ndebele" },
  nde: { id: "nde", alpha2: "nd", nameFi: "pohjois-ndebele" },
  ndo: { id: "ndo", alpha2: "ng", nameFi: "ndonga" },
  nep: { id: "nep", alpha2: "ne", nameFi: "nepali" },
  nld: { id: "nld", alpha2: "nl", nameFi: "hollanti" },
  nno: { id: "nno", alpha2: "nn", nameFi: "norjan nynorsk" },
  nob: { id: "nob", alpha2: "nb", nameFi: "norjan bokmål" },
  nor: { id: "nor", alpha2: "no", nameFi: "norja" },
  nya: { id: "nya", alpha2: "ny", nameFi: "njandža" },
  oci: { id: "oci", alpha2: "oc", nameFi: "oksitaani" },
  oji: { id: "oji", alpha2: "oj", nameFi: "odžibwa" },
  ori: { id: "ori", alpha2: "or", nameFi: "orija" },
  orm: { id: "orm", alpha2: "om", nameFi: "oromo" },
  oss: { id: "oss", alpha2: "os", nameFi: "osseetti" },
  pan: { id: "pan", alpha2: "pa", nameFi: "pandžabi" },
  pli: { id: "pli", alpha2: "pi", nameFi: "paali" },
  pol: { id: "pol", alpha2: "pl", nameFi: "puola" },
  por: { id: "por", alpha2: "pt", nameFi: "portugali" },
  prs: { id: "prs", alpha2: "", nameFi: "dari" },
  pus: { id: "pus", alpha2: "ps", nameFi: "paštu" },
  que: { id: "que", alpha2: "qu", nameFi: "ketšua" },
  roh: { id: "roh", alpha2: "rm", nameFi: "retoromaani" },
  rom: { id: "rom", alpha2: "", nameFi: "romani" },
  ron: { id: "ron", alpha2: "ro", nameFi: "romania" },
  run: { id: "run", alpha2: "rn", nameFi: "rundi" },
  rus: { id: "rus", alpha2: "ru", nameFi: "venäjä" },
  sag: { id: "sag", alpha2: "sg", nameFi: "sango" },
  san: { id: "san", alpha2: "sa", nameFi: "sanskrit" },
  sin: { id: "sin", alpha2: "si", nameFi: "sinhala" },
  slk: { id: "slk", alpha2: "sk", nameFi: "slovakki" },
  slv: { id: "slv", alpha2: "sl", nameFi: "sloveeni" },
  sme: { id: "sme", alpha2: "se", nameFi: "pohjoissaame" },
  smn: { id: "smn", alpha2: "", nameFi: "inarinsaame" },
  smo: { id: "smo", alpha2: "sm", nameFi: "samoa" },
  sms: { id: "sms", alpha2: "", nameFi: "koltansaame" },
  sna: { id: "sna", alpha2: "sn", nameFi: "šona" },
  snd: { id: "snd", alpha2: "sd", nameFi: "sindhi" },
  som: { id: "som", alpha2: "so", nameFi: "somali" },
  sot: { id: "sot", alpha2: "st", nameFi: "eteläsotho" },
  spa: { id: "spa", alpha2: "es", nameFi: "espanja" },
  sqi: { id: "sqi", alpha2: "sq", nameFi: "albania" },
  srd: { id: "srd", alpha2: "sc", nameFi: "sardi" },
  srp: { id: "srp", alpha2: "sr", nameFi: "serbia" },
  ssw: { id: "ssw", alpha2: "ss", nameFi: "swazi" },
  sun: { id: "sun", alpha2: "su", nameFi: "sunda" },
  swa: { id: "swa", alpha2: "sw", nameFi: "swahili" },
  swe: { id: "swe", alpha2: "sv", nameFi: "ruotsi" },
  tah: { id: "tah", alpha2: "ty", nameFi: "tahiti" },
  tam: { id: "tam", alpha2: "ta", nameFi: "tamili" },
  tat: { id: "tat", alpha2: "tt", nameFi: "tataari" },
  tel: { id: "tel", alpha2: "te", nameFi: "telugu" },
  tgk: { id: "tgk", alpha2: "tg", nameFi: "tadžikki" },
  tgl: { id: "tgl", alpha2: "tl", nameFi: "tagalog" },
  tha: { id: "tha", alpha2: "th", nameFi: "thai" },
  tir: { id: "tir", alpha2: "ti", nameFi: "tigrinja" },
  ton: { id: "ton", alpha2: "to", nameFi: "tonga" },
  tsn: { id: "tsn", alpha2: "tn", nameFi: "tswana" },
  tso: { id: "tso", alpha2: "ts", nameFi: "tsonga" },
  tuk: { id: "tuk", alpha2: "tk", nameFi: "turkmeeni" },
  tur: { id: "tur", alpha2: "tr", nameFi: "turkki" },
  twi: { id: "twi", alpha2: "tw", nameFi: "twi" },
  uig: { id: "uig", alpha2: "ug", nameFi: "uiguuri" },
  ukr: { id: "ukr", alpha2: "uk", nameFi: "ukraina" },
  urd: { id: "urd", alpha2: "ur", nameFi: "urdu" },
  uzb: { id: "uzb", alpha2: "uz", nameFi: "uzbekki" },
  ven: { id: "ven", alpha2: "ve", nameFi: "venda" },
  vie: { id: "vie", alpha2: "vi", nameFi: "vietnam" },
  vol: { id: "vol", alpha2: "vo", nameFi: "volapük" },
  wln: { id: "wln", alpha2: "wa", nameFi: "valloni" },
  wol: { id: "wol", alpha2: "wo", nameFi: "wolof" },
  xho: { id: "xho", alpha2: "xh", nameFi: "xhosa" },
  yid: { id: "yid", alpha2: "yi", nameFi: "jiddiš" },
  yor: { id: "yor", alpha2: "yo", nameFi: "joruba" },
  zha: { id: "zha", alpha2: "za", nameFi: "zhuang" },
  zho: { id: "zho", alpha2: "zh", nameFi: "kiina" },
  zul: { id: "zul", alpha2: "zu", nameFi: "zulu" },
}
export { isoLanguages }